// Auto-generated by node_modules/@cudirect/builders/bin/generate-build-info.js
export const LIB_NAME = "arcdx";
export const LIB_VERSION = "6.0.1";
